module.exports = __webpack_public_path__ + "static/media/dsc_0393.6da69782.jpg";